import { jsx as v } from "react/jsx-runtime";
import * as r from "react";
import { resolveTheme as p, applyTheme as i } from "./apply-theme.js";
const u = r.createContext(null);
function x() {
  const s = r.useContext(u);
  if (!s) throw new Error("useTheme must be used within a <ThemeProvider>");
  return s;
}
function y({
  children: s,
  defaultMode: a = "system",
  mode: m,
  onModeChange: o
}) {
  const n = m !== void 0, [d, l] = r.useState(a), e = n ? m : d, f = p(e);
  r.useEffect(() => {
    if (i(e), e !== "system") return;
    const t = window.matchMedia("(prefers-color-scheme: dark)"), c = () => i("system");
    return t.addEventListener("change", c), () => t.removeEventListener("change", c);
  }, [e]);
  const h = r.useCallback(
    (t) => {
      n ? o == null || o(t) : l(t);
    },
    [n, o]
  );
  return /* @__PURE__ */ v(u.Provider, { value: { mode: e, resolvedMode: f, setMode: h }, children: s });
}
export {
  u as ThemeContext,
  y as ThemeProvider,
  x as useTheme
};
//# sourceMappingURL=ThemeProvider.js.map
